import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getRequirements, getTac, updateTac } from '../../actions/AuthAction'
import Modal, { ModalBody, ModalFooter } from '../Modal'
import Button from '../Button'
import Notice from '../Notice'
import * as ts from '../../services/translationService'
import Markdown from '../Markdown/Markdown'

export const BackgroundChecks = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.AuthReducer.user)
  const requirements = useSelector(state => state.AuthReducer.requirements)
  const tac = useSelector(state => state.AuthReducer.tac)
  const showUpdateTac = React.useMemo(
    () => {
      if (!user || !requirements || !user.accessToken) {
        return false
      }
      const tacIntake = user.tac && user.tac.intake

      if (!tacIntake || (tacIntake && tacIntake.version && tacIntake.version < requirements.intakeRequiredTac)) {
        return true
      }

      return false
    },
    [user, requirements],
  )

  // Lifecycle methods
  React.useEffect(() => {
    dispatch(getTac())
    dispatch(getRequirements())
  }, [])

  // Events
  const handleConfirm = () => {
    dispatch(updateTac(tac.id, tac.version))
  }

  return (
    <React.Fragment>
      {tac && (
        <Modal
          isOpen={showUpdateTac}
          shouldCloseOnOverlayClick={false}
          title={ts.TACUpdateHeading()}
          hasDismiss={false}>
          <ModalBody id="sceneModal">
            <Notice type="warning">{ts.TACUpdateDescription()}</Notice>
            <Markdown source={tac.content} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleConfirm} primary>
              {ts.TACUpdateAcceptAction()}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </React.Fragment>
  )
  // return <Modal isOpen={showUpdateTac} platform={'intake'} locale={getLocale()} />
}



// WEBPACK FOOTER //
// ./src/components/BackgroundChecks/BackgroundChecks.js